<template>
    <header class="header header__fixed">
        <div class="header__row header__row--top">
            <!--Logo-->
            <header-logo :render="render" :partner-logo="partnerLogo"></header-logo>

            <!--Web menu-->
            <header-sections v-if="userPlatform === 'web'" :is-admin="isAdmin" :render="render"
                             :sections.sync="sections"/>

            <div class="header__buttons">

                <div v-if="userPlatform === 'mobile'" v-html="headerButtonHtml"></div>

                <!--Search button-->
                <router-link v-if="!render"
                             :to="{ name: 'search' }"
                             class="btn btn--white-bg header__button header__button--icon"
                >
                    <svg class="header__buttons--icon-search" width="21" height="21">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-search"></use>
                    </svg>
                </router-link>

                <!--Desktop button-->
                <header-desktop-button v-if="isAdmin && userPlatform === 'web'"></header-desktop-button>

                <div v-if="userPlatform === 'mobile'" class="btn btn--white-bg header__button header__button--icon">
                    <router-link v-if="!user" :to="{name: 'login'}">
                        <svg class="header__buttons--icon-user" width="19" height="19">
                            <use xlink:href="/assets/front/img/sprite.svg#icon-user"></use>
                        </svg>
                    </router-link>

                    <svg v-else width="60" height="60" @click="showProfile">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-auth"></use>
                    </svg>
                </div>

                <template v-if="userPlatform === 'mobile'">
                    <header-mobile-menu ref="mobileMenu" @beforeShow="currentSectionActive">
                        <template v-if="mobileMenu.switchBody">
                            <div>
                                <div class="header__buttons-menu">
                                    <header-pages :render="true"  :pages="sections[4].pages"></header-pages>
                                </div>
                            <header-mobile-section v-for="(section, index) in sections"
                                                   :key="index"
                                                   @close="() => $refs.mobileMenu.hide()"
                                                   @showSection="showSection"
                                                   :section="section"/>
                            </div>
                        </template>
                        <header-profile :is-admin="isAdmin" v-else/>
                    </header-mobile-menu>
                </template>

                <!--Login button for render-->
                <header-login-button-render v-if="render && userPlatform === 'web'"/>

                <!--Login button-->
                <header-login-button v-if="!render && !user && userPlatform === 'web'"/>

                <!--Profile button-->
                <el-popover v-if="!render && user && userPlatform === 'web'"
                            placement="bottom-end"
                            :popper-class="popoverClass"
                            trigger="hover">
                    <template>
                        <header-profile :isAdmin="isAdmin"/>
                    </template>

                    <template #reference>
                        <button
                            class="btn btn--white-bg header__button header__button--icon"
                            :dusk="'popover-out'"
                            type="button">
                            <svg v-if="!user" width="19" height="19">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-user"></use>
                            </svg>
                            <svg v-if="user" width="60" height="60">
                                <use xlink:href="/assets/front/img/sprite.svg#icon-auth"></use>
                            </svg>
                        </button>
                    </template>
                </el-popover>
            </div>
        </div>
    </header>
</template>

<script>
import HeaderSections from './HeaderSections'
import HeaderProfile from "./HeaderProfile";
import HeaderLoginButton from "./HeaderLoginButton";
import HeaderDesktopButton from "./HeaderDesktopButton";
import HeaderLogo from "./HeaderLogo";
import HeaderNavMobile from "./HeaderNavMobile";
import HeaderLoginButtonRender from "./HeaderLoginButtonRender";
import {mapState} from "vuex";
import HeaderPages from "./HeaderPages";
import HeaderMobileMenu from "./headerMobile/HeaderMobileMenu.vue";
import HeaderMobileSection from "./headerMobile/HeaderMobileSection.vue";
import mobileMenu from "./mixins/MobileMenu";

export default {
    name: "Header",
    mixins: [mobileMenu],
    props: {
        hasServices: {
            default: false
        },
        render: {
            default: false
        },
        partnerLogo: {
            default: null
        }
    },
    components: {
        HeaderMobileSection,
        HeaderMobileMenu,
        HeaderLogo,
        HeaderSections,
        HeaderPages,
        HeaderNavMobile,
        HeaderDesktopButton,
        HeaderLoginButton,
        HeaderLoginButtonRender,
        HeaderProfile
    },
    data() {
        return {
            prefix: window.laravel.prefix,
            user: window.laravel.user,
            isAdmin: window.laravel.isAdmin,
        }
    },
    computed: {
        ...mapState('header', [
            'headerButtonHtml',
        ]),
        userPlatform() {
            return this.windowWidth < 1200 ? 'mobile' : 'web';
        },
        popoverClass() {
            return this.isAdmin ? 'popover-class' : '';
        }
    },
}
</script>

